export default "__VITE_ASSET__43a9990f__"